import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import debounce from 'lodash/debounce';

type PageViewServiceProps = {
  fireEvent: (event: Event) => void;
};

type Location = ReturnType<typeof useLocation>;
type Event = { name: string; pathname: string; url: string };

const PageViewService = ({ fireEvent }: PageViewServiceProps) => {
  const history = useHistory();
  const location = useLocation();

  const generateEvent = (location: Location): Event => ({
    name: 'PAGE_VIEW',
    pathname: location?.pathname,
    url: `${window.location.origin}${location?.pathname}`,
  });

  useEffect(() => {
    const stopListen = history.listen(
      debounce((event: Location) => {
        fireEvent(generateEvent(event));
      }, 200),
    );
    return () => stopListen();
  }, []);

  useEffect(() => {
    // dispatch PAGE_VIEW on mount

    fireEvent(generateEvent(location));
  }, []);

  return null;
};

export default PageViewService;
